const binding = { modules: {}, dataActions: {} };

    (binding.modules['lianxin-theme'] = {
        c: () => require('partner/themes/lianxin-theme/lianxin-theme.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lianxin-theme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'lianxin-theme.theme.settings.json',
        md: 'src/themes/lianxin-theme'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };